import { missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'socialGallery-container';

export default function socialGallery() {
  const widgetName = 'socialGallery';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof socialGalleryOpts === 'undefined' ? null : socialGalleryOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSocialGallery(data.items, $widget);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
}

function createCustomSocialGallery(widgetData, $widget) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);

    updateLinksAttributes(URL, Title, $cardItem);
  });
}
